import { ApiHttpService, ApiHttpServiceNewApi } from '../ApiHttpService';
import { UserSerializer } from '../serializers/UserSerializer';
import { User } from '../../models/User';

const EDIT_PASSWORD = 'usuario/CambiarPWDLogueado/';
const GET_USER = 'usuario/';
const LOGIN_PATH = 'usuario/login/';
const REGISTER_PATH = 'usuario/CrearCuenta/';
const RENEW_TOKEN_PATH = 'usuario/RefreshToken/';
const UPDATE_USER = 'usuario/EditCuenta/';

const NEWAPI_LOGIN_PATH = 'Client/signin';

const USER_TYPE_ENUM = {
  PERSON: 1,
  COMPANY: 2,
};

class SessionController {
  static async login(email, password) {
    const body = {
      CWeMail: email,
      CWePwd: password,
    };
    const response = await ApiHttpService.post(LOGIN_PATH, body);
    const [token, refreshToken, user] = response.data;
    const deserializedUser = UserSerializer.deSerialize(user);
    // if (true) {
    //   throw new Error('Exception message');
    // }
    return {
      token,
      refreshToken,
      user: new User(deserializedUser),
    };
  }

  static async loginNewApi(email, password) {
    const body = {
      identifier: email,
      password,
    };
    const response = await ApiHttpServiceNewApi.post(NEWAPI_LOGIN_PATH, body);
    const { token } = response.data.data;
    return {
      tokenNewApi: token,
    };
  }

  /*
    NOTE: This is an internal function, use the specific
    register functions from the outside.
  */
  static async register(data) {
    const headers = {
      captcha: data.recaptchaToken,
    };
    const response = await ApiHttpService.post(REGISTER_PATH, data, false, { headers });
    const [token, refreshToken, user] = response.data;
    const deserializedUser = UserSerializer.deSerialize(user);
    return {
      token,
      refreshToken,
      user: new User(deserializedUser),
    };
  }

  /*
    NOTE: Persons also include unipersonal companies.
  */
  static registerPerson(data) {
    const dataToSend = {
      CWeMail: data.email,
      CWePwd: data.password,
      CWeNombres: data.names,
      CWeApellidos: data.surnames,
      recaptchaToken: data.recaptchaToken,
      Cliente: {
        CliTipo: USER_TYPE_ENUM.PERSON,
        CliCiRuc: data.personalId,
        CliPaisDelDocumento: data.selectedCountry,
      },
    };
    if (data.rut) {
      dataToSend.CWeRut = data.rut;
    }
    return SessionController.register(dataToSend);
  }

  static registerCompany(data) {
    const dataToSend = {
      CWeMail: data.email,
      CWePwd: data.password,
      recaptchaToken: data.recaptchaToken,
      Cliente: {
        CliTipo: USER_TYPE_ENUM.COMPANY,
        CliCiRuc: data.rut,
        CEmpresa: {
          CEmNombre: data.tradeName,
          CEmFantasia: data.fictitiousName,
        },
      },
    };
    return SessionController.register(dataToSend);
  }

  static renewToken(refreshToken) {
    return ApiHttpService.post(RENEW_TOKEN_PATH, {
      Token: refreshToken,
    });
  }

  static async getUser() {
    const authenticated = true;
    const response = await ApiHttpService.get(GET_USER, {}, authenticated);
    const user = response.data;
    const deserializedUser = UserSerializer.deSerialize(user);
    return new User(deserializedUser);
  }

  /*
    NOTE: Persons also include unipersonal companies.
  */
  static async updatePerson(data) {
    const authenticated = true;
    const body = {
      CWeId: data.id,
      CWeMail: data.email,
      CWeNombres: data.names,
      CWeApellidos: data.surnames,
      Cliente: {
        CliTipo: USER_TYPE_ENUM.PERSON,
        CliCiRuc: data.document,
        CliPaisDelDocumento: data.documentCountry,
      },
    };
    if (data.rut) {
      body.CWeRUT = data.rut;
    }
    const response = await ApiHttpService.post(UPDATE_USER, body, authenticated);
    const deserializedUser = UserSerializer.deSerialize(response.data);
    return new User(deserializedUser);
  }

  static async updateCompany(data) {
    const authenticated = true;
    const body = {
      CWeId: data.id,
      CWeMail: data.email,
      Cliente: {
        CliTipo: USER_TYPE_ENUM.COMPANY,
        CliCiRuc: data.rut,
        CEmpresa: {
          CEmNombre: data.tradeName,
          CEmFantasia: data.fictitiousName,
        },
      },
    };
    const response = await ApiHttpService.post(UPDATE_USER, body, authenticated);
    const deserializedUser = UserSerializer.deSerialize(response.data);
    return new User(deserializedUser);
  }

  static async editPassword(data) {
    const authenticated = true;
    const body = {
      PWDold: data.actualPassword,
      PWD: data.newPassword,
    };
    const headers = {
      captcha: data.recaptchaToken,
    };
    await ApiHttpService.post(EDIT_PASSWORD, body, authenticated, { headers });
  }
}

export { SessionController };



// WEBPACK FOOTER //
// ./src/networking/controllers/SessionController.js